export const HEADER_ACTION_DEFINITIONS = [
  {
    key: 'bot',
    label: 'Перейти к боту',
    title: 'Перейти к боту',
    destination: { kind: 'bot' },
    placements: { desktopQuick: true, desktopMenu: false, mobileMenu: true },
    classNames: {
      mobile: 'btn header-menu-action header-menu-action--bot',
    },
    icons: {
      mobile: { name: 'plane', className: 'icon--h18 icon--middle icon--mr10' },
    },
  },
  {
    key: 'proxy',
    label: 'Прокси',
    destination: { kind: 'route', to: '/proxy' },
    placements: { desktopQuick: false, desktopMenu: true, mobileMenu: true },
    classNames: {
      desktop: 'btn header-menu-action header-menu-action--secondary header-menu-action--proxy',
      mobile: 'btn header-menu-action header-menu-action--secondary header-menu-action--proxy',
    },
    icons: {
      desktop: { name: 'plug', className: 'icon--mr10 icon--middle' },
      mobile: { name: 'plug', className: 'icon--h18 icon--middle icon--mr10' },
    },
  },
  {
    key: 'support',
    label: 'Поддержка',
    destination: { kind: 'support' },
    placements: { desktopQuick: false, desktopMenu: true, mobileMenu: true },
    classNames: {
      desktop: 'btn header-menu-action header-menu-action--secondary header-menu-action--support',
      mobile: 'btn header-menu-action header-menu-action--secondary header-menu-action--support',
    },
    icons: {
      desktop: { name: 'support', className: 'icon--mr10 icon--middle icon--translate-y-05' },
      mobile: { name: 'support', className: 'icon--mr10 icon--middle icon--translate-y-2' },
    },
  },
  {
    key: 'terms',
    label: 'Условия и политика',
    title: 'Условия и политика',
    destination: { kind: 'route', to: '/terms-policy' },
    placements: { desktopQuick: false, desktopMenu: true, mobileMenu: true },
    classNames: {
      desktop: 'btn header-menu-action header-menu-action--secondary header-menu-action--terms',
      mobile: 'btn header-menu-action header-menu-action--secondary header-menu-action--terms',
    },
    icons: {
      desktop: { name: 'terms', className: 'icon--h18 icon--middle icon--mr10' },
      mobile: { name: 'terms', className: 'icon--h18 icon--middle icon--mr10', props: { stroke: '#000000', fill: '#000000' } },
    },
  },
];

export const HEADER_PAGE_PRESETS = {
  default: {
    showBackButton: false,
    showMobileMenuToggle: true,
    showDesktopBotButton: true,
    hiddenActionKeys: [],
  },
  proxy: {
    showBackButton: true,
    showMobileMenuToggle: false,
    showDesktopBotButton: true,
    hiddenActionKeys: ['proxy', 'support', 'terms'],
  },
  termsPolicy: {
    showBackButton: true,
    showMobileMenuToggle: false,
    showDesktopBotButton: true,
    hiddenActionKeys: ['support', 'terms'],
  },
};

const ACTION_OVERRIDE_KEYS = ['bot', 'proxy', 'support', 'terms'];

export function resolveHeaderPagePresetKey(pathname) {
  if (pathname === '/proxy') return 'proxy';
  if (pathname === '/terms-policy') return 'termsPolicy';
  return 'default';
}

export function resolveHeaderPageConfig(pathname, overrides = {}) {
  const presetKey = resolveHeaderPagePresetKey(pathname);
  const preset = HEADER_PAGE_PRESETS[presetKey] || HEADER_PAGE_PRESETS.default;
  const hiddenActionKeys = new Set(preset.hiddenActionKeys);

  ACTION_OVERRIDE_KEYS.forEach((actionKey) => {
    if (overrides[actionKey] === true) {
      hiddenActionKeys.add(actionKey);
    }
  });

  return {
    presetKey,
    showBackButton: preset.showBackButton,
    showMobileMenuToggle: overrides.menuToggle === true ? false : preset.showMobileMenuToggle,
    showDesktopBotButton: overrides.bot === true ? false : preset.showDesktopBotButton,
    hiddenActionKeys: Array.from(hiddenActionKeys),
  };
}
